import { Alert, Loader, Stack } from '@mantine/core'
import { IconAlertCircle } from '@tabler/icons-react'
import { useTrackDeviceInfo } from '../api/devices'
import TrackMapContainer from './TrackMapContainer'

type Props = {
  deviceImei: string
  start: Date
  end: Date
}

export function DeviceDetails({ deviceImei, start, end }: Props) {
  const {
    data: device,
    isPending: devicePending,
    isError: deviceError,
    error,
  } = useTrackDeviceInfo(deviceImei, start, end)

  if (devicePending) {
    return (
      <Stack align="center" justify="center" maw="100%">
        <Loader />
      </Stack>
    )
  }

  if (deviceError) {
    return (
      <Stack align="center" justify="center" maw="100%">
        <Alert icon={<IconAlertCircle size="1rem" />} title="Error" color="red">
          {error.message}
        </Alert>
      </Stack>
    )
  }

  return (
    <div style={{ width: '100%', height: '100%', padding: '0 75px 20px 75px' }}>
      <h1>Details for {device.device} </h1>
      {!!device.track && (
        <TrackMapContainer
          track={device.track}
          deviceImei={deviceImei}
          startDate={start}
          endDate={end}
        />
      )}
      {!device.track && (
        <Alert
          icon={<IconAlertCircle size="1rem" />}
          maw={500}
          title="Info"
          color="blue"
        >
          NO DATA FROM THIS DEVICE FOR THIS PERIOD.
        </Alert>
      )}
    </div>
  )
}
